<script>
import { Validator } from 'vee-validate'
import { putLocaleUserSettings } from '../api'
import i18n from '../constants/lang/i18n'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      locale: i18n.locale
    }
  },
  computed: {
    ...mapGetters([
      'isLogin'
    ]),
    languageValueMap () {
      return this.languageOptions.reduce((map, option) => ({ ...map, [option.value]: option }), {})
    },
    // static
    languageOptions () {
      return [
        {
          title: 'English',
          value: 'en'
        },
        {
          title: '日本語',
          value: 'ja'
        }
      ]
    }
  },
  methods: {
    setLang (locale) {
      i18n.locale = locale
      Validator.localize(locale)
      localStorage.setItem('locale', locale)
      this.locale = locale
      if (this.isLogin) {
        this.setServerLang(locale)
      }
    },
    async setServerLang (locale) {
      try {
        let config = this.$ls.get('userInfo')
        locale = locale || i18n.locale
        await putLocaleUserSettings(locale, config)
      } catch (error) {
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/mixins/locale.vue